import DebouncedTextField from "@common/components/DebouncedTextField";
import Typography from "@common/components/Typography";
import { FormLabel } from "@mui/material";
import { ColDefWithTab } from "@pages/Assets/common/FilterColumn/context";
import { SnmpEntry } from "@services/catalog/types";
import { TFunction } from "react-i18next";

export interface SnmpEntryWithIndex extends SnmpEntry {
  index: number;
}

export const getColumns = (
  canEdit: boolean,
  t: TFunction<"translation", undefined>,
  isCustom: boolean,
  handleNameChange: (row: SnmpEntryWithIndex) => void,
  handleOidChange: (row: SnmpEntryWithIndex) => void,
  handleDataChangeFlag: () => void
): ColDefWithTab<SnmpEntryWithIndex>[] => {
  return [
    {
      key: "index",
      label: "index",
      show: false,
    },
    {
      key: "name",
      label: "Label",
      sortable: true,
      renderHeader: () => <FormLabel required>{t("Label")}</FormLabel>,
      render: (row) => (
        <>
          {isCustom ? (
            <DebouncedTextField
              disabled={!canEdit}
              fullWidth
              variant="outlined"
              value={row.name}
              name="name"
              immediateCallback={handleDataChangeFlag}
              onChange={(value) =>
                handleNameChange({
                  ...row,
                  name: value,
                })
              }
            />
          ) : (
            <Typography size="small" textAlign="left" sx={{ width: "100%" }}>
              {row.name}
            </Typography>
          )}
        </>
      ),
    },
    {
      key: "oid",
      label: "OID",
      sortable: true,
      renderHeader: () => <FormLabel required>{t("OID")}</FormLabel>,
      render: (row) => (
        <>
          {isCustom ? (
            <DebouncedTextField
              disabled={!canEdit}
              fullWidth
              value={row.oid}
              name="oid"
              variant="outlined"
              required
              immediateCallback={handleDataChangeFlag}
              onChange={(value) =>
                handleOidChange({
                  ...row,
                  oid: value,
                })
              }
            />
          ) : (
            <Typography size="small" textAlign="left" sx={{ width: "100%" }}>
              {row.oid}
            </Typography>
          )}
        </>
      ),
    },
  ];
};
